<template>
  <div>
    <div class="traf-btn">
      <el-button type="primary" @click="addCustomer">新增客户</el-button>
      <el-button type="success" @click="addconsulting">咨询工单</el-button>
      <el-button type="info" @click="addEntity">实体工单</el-button>
      <el-button type="warning">查看客户</el-button>
    </div>

    <div class="traf-ta">
      <div>
        <div class="ta-title">通话记录</div>
        <div>
          <el-table
            :data="callList"
            border
            style="width: 100%"
            :header-cell-style="{
              background: '#f2f2f2',
              color: '#000',
            }"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="agentId"
              label="操作员"
              align="center"
              width="120"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="remoteNum"
              label="对端号码"
              align="center"
              width="180"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="callType"
              label="通话类型"
              align="center"
              width="160"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="timeLen"
              label="通话时长"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
          </el-table>
          <Paginationmini
            :pageConfig="pageConfig1"
            @currentPage="currentChange1"
            @pageSize="pageSizeChange1"
          ></Paginationmini>
        </div>
      </div>
      <div>
        <div class="ta-title">咨询工单</div>
        <div>
          <el-table
            :data="consultingList"
            border
            style="width: 100%"
            :header-cell-style="{
              background: '#f2f2f2',
              color: '#000',
            }"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="ordernum"
              label="工单流水号"
              align="center"
              width="180"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="callPhone"
              label="来电号码"
              align="center"
              width="160"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="seatPerson"
              label="受理人员"
              align="center"
              width="120"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="adviceContent"
              label="咨询内容"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
          </el-table>
          <Paginationmini
            :pageConfig="pageConfig2"
            @currentPage="currentChange2"
            @pageSize="pageSizeChange2"
          ></Paginationmini>
        </div>
      </div>
    </div>

    <div class="traf-ta">
      <div>
        <div class="ta-title">实体工单</div>
        <div>
          <el-table
            :data="entityList"
            border
            style="width: 100%"
            :header-cell-style="{
              background: '#f2f2f2',
              color: '#000',
            }"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="states"
              label="处理结果"
              :formatter="statesFormat"
              align="center"
              width="120"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="orderNum"
              label="工单流水号"
              align="center"
              width="120"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="customerName"
              label="客户姓名"
              align="center"
              width="120"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="servestationName"
              label="机构"
              align="center"
              width="120"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="servePersonName"
              label="服务人员"
              align="center"
              width="120"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="serveproductName"
              label="服务名称"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
          </el-table>
          <Paginationmini
            :pageConfig="pageConfig3"
            @currentPage="currentChange3"
            @pageSize="pageSizeChange3"
          ></Paginationmini>
        </div>
      </div>
      <div>
        <div class="ta-title">回访记录</div>
        <div>
          <el-table
            :data="returnVisitList"
            border
            style="width: 100%"
            :header-cell-style="{
              background: '#f2f2f2',
              color: '#000',
            }"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="visitTime"
              label="时间"
              align="center"
              width="180"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="visitName"
              label="回访类型"
              align="center"
              width="160"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="note"
              label="通话记录"
              align="center"
              width="120"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="note"
              label="回访流程"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
          </el-table>
          <Paginationmini
            :pageConfig="pageConfig4"
            @currentPage="currentChange4"
            @pageSize="pageSizeChange4"
          ></Paginationmini>
        </div>
      </div>
    </div>
    <AddCustomer :show-customer.sync="showAddCustomer"></AddCustomer>
    <AddConsulting
      :show-consulting.sync="showAddConsulting"
      @sXval="sXval"
    ></AddConsulting>
    <AddEntity :show-entity.sync="showAddEntity"></AddEntity>
  </div>
</template>

<script>
import globalTag from "../components/globalTag"
import AddCustomer from "./component/addCustomer.vue"
import AddConsulting from "./component/addConsulting.vue"
import AddEntity from "./component/addEntity.vue"
import headLine from "../components/headline"
import request from "@/utils/request.js"
import Paginationmini from "./component/pagination-mini"
export default {
  components: {
    globalTag,
    AddCustomer,
    AddConsulting,
    AddEntity,
    headLine,
    Paginationmini,
  },
  props: {
    val: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      queryForm: {},
      callList: [],
      consultingList: [],
      entityList: [],
      returnVisitList: [],
      showAddCustomer: false,
      showAddConsulting: false,
      showAddEntity: false,
      setVal: {},

      pageConfig1: {
        pageSize: 6,
        total: 0,
        pageNo: 1,
      },
      pageConfig2: {
        pageSize: 6,
        total: 0,
        pageNo: 1,
      },
      pageConfig3: {
        pageSize: 6,
        total: 0,
        pageNo: 1,
      },
      pageConfig4: {
        pageSize: 6,
        total: 0,
        pageNo: 1,
      },
    }
  },
  mounted() {},
  watch: {
    val(newVal) {
      console.log(newVal, 111)
      this.setVal = newVal
      console.log("传过来的值", this.setVal)
      this.getTHList()
      this.getZXList()
      this.getSTList()
      this.geHFList()
    },
  },
  methods: {
    sXval(sXval) {
      console.log("子组件传值过来", sXval)
      if (sXval == 2) {
        this.getZXList()
      }
    },
    //实体工单处理结果状态
    statesFormat(row, column) {
      if (row.states === 0) {
        return "待派发"
      } else if (row.states === 1) {
        return "待处理"
      } else if (row.states === 2) {
        return "待回访"
      } else if (row.states === 3) {
        return "服务完成"
      } else if (row.states === 4) {
        return "待作废"
      } else if (row.states === 5) {
        return "已作废"
      } else if (row.states === 100) {
        return "移动终端接单"
      }
    },
    //通话记录页码改变
    currentChange1(currentPage) {
      this.pageConfig1.pageNo = currentPage
      this.getTHList()
    },
    pageSizeChange1(size) {
      this.pageConfig1.pageSize = size
    },
    //咨询工单页码改变
    currentChange2(currentPage) {
      this.pageConfig2.pageNo = currentPage
      this.getZXList()
    },
    pageSizeChange2(size) {
      this.pageConfig2.pageSize = size
    },
    //实体工单页码改变
    currentChange3(currentPage) {
      this.pageConfig3.pageNo = currentPage
      this.getSTList()
    },
    pageSizeChange3(size) {
      this.pageConfig3.pageSize = size
    },
    //回访记录页码改变
    currentChange4(currentPage) {
      this.pageConfig4.pageNo = currentPage
      this.getHFList()
    },
    pageSizeChange4(size) {
      this.pageConfig4.pageSize = size
    },
    //查询通话记录
    getTHList() {
      request({
        url: "/jjyl/recFile/info/findRecFileInfo",
        method: "POST",
        data: {
          belongAddressId: "06a942d7-0241-4428-8f6f-bbf0695e60ae",
          isCall: 0,
          pageNo: 1,
          pageSize: 10,
          remoteNum: this.setVal.content.phone,
        },
      }).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.callList = resp.content.list
            this.pageConfig1.total = resp.content.count
            console.log(this.pageConfig1.total)
          } else {
            console.log(resp)
          }
        }
      })
    },
    //查询咨询工单
    getZXList() {
      request({
        url: "/jjyl/advicepgd/info/findAdvicepgd",
        method: "POST",
        data: {
          belongAddressId: "06a942d7-0241-4428-8f6f-bbf0695e60ae",
          isCall: 0,
          pageNo: 1,
          pageSize: 10,
          callPhone: this.setVal.content.phone,
        },
      }).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.consultingList = resp.content.list
            this.pageConfig2.total = resp.content.count
          } else {
            console.log(resp)
          }
        }
      })
    },
    //查询实体工单
    getSTList() {
      request({
        url: "/jjyl/servicePgd/info/findServicepgd",
        method: "POST",
        data: {
          belongAddressId: "06a942d7-0241-4428-8f6f-bbf0695e60ae",
          isCall: 0,
          pageNo: 1,
          pageSize: 10,
          customerphone: this.setVal.content.phone,
        },
      }).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.entityList = resp.content.list
          } else {
            console.log(resp)
          }
        }
      })
    },
    //查询回访记录
    geHFList() {
      request({
        url: "/jjyl/returnPgd/info/findReturnPgd",
        method: "POST",
        data: {
          belongAddressId: "06a942d7-0241-4428-8f6f-bbf0695e60ae",
          isCall: 0,
          pageNo: 1,
          pageSize: 10,
          customerPhone: this.setVal.content.phone,
        },
      }).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.returnVisitList = resp.content.list
          } else {
            console.log(resp)
          }
        }
      })
    },
    QuerySearch() {},
    addCustomer() {
      this.$router.push("/electronics")
      // this.showAddCustomer = true
    },
    addconsulting() {
      this.showAddConsulting = true
    },
    addEntity() {
      // this.showAddEntity = true
      this.$router.push({
        path: "/infoOrder1",
        query: {
          show: 1,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.traf-btn {
  width: 100%;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;

  /deep/ .el-button {
    width: 24%;
    height: 50px;
  }
}

.traf-ta {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.traf-ta > div {
  width: 49%;
}

.ta-title {
  height: 20px;
}
</style>
